<script setup lang="ts">
import { EntityListPage, type EntityConfig } from '@botto/core';
import { messageTypesStore } from '../../api';
import type { MessageType } from '../../api';

const SMS_TYPE_OPTIONS = [
  { value: 'ads', text: 'Рекламные' },
  { value: 'ads_custom', text: 'Рекламные (кастом)' },
  { value: 'ads_template', text: 'Рекламные (шаблон)' },
  { value: 'service', text: 'Сервисные' },
  { value: 'identification', text: 'Идентификация' },
  { value: 'information', text: 'Информационные' },
  { value: 'authorization', text: 'Авторизация' },
];

const typeLabel = (value: string | null | undefined): string =>
  SMS_TYPE_OPTIONS.find((o) => o.value === value)?.text ?? value ?? '';

const config: EntityConfig<MessageType> = {
  title: 'Тип сообщения',
  titlePlural: 'Типы сообщений',
  popupWidth: 560,
  popupHeight: 480,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'title', caption: 'Название' },
    { dataField: 'sender_name', caption: 'Имя отправителя', width: 160 },
    {
      dataField: 'type',
      caption: 'Тип SMS',
      width: 180,
      calculateDisplayValue: (row) => typeLabel(row.type),
    },
    { dataField: 'skip_moderation', caption: 'Без модерации', dataType: 'boolean', width: 130 },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'title', label: 'Название', required: true, colSpan: 2 },
    { dataField: 'sender_name', label: 'Имя отправителя', required: true, colSpan: 2 },
    {
      dataField: 'type',
      label: 'Тип SMS',
      required: true,
      editorType: 'dxSelectBox',
      editorOptions: {
        items: SMS_TYPE_OPTIONS,
        displayExpr: 'text',
        valueExpr: 'value',
        searchEnabled: true,
      },
    },
    {
      dataField: 'skip_moderation',
      label: 'Пропустить модерацию',
      editorType: 'dxCheckBox',
    },
  ],
};
</script>

<template>
  <EntityListPage :config="config" :store="messageTypesStore" />
</template>
